import React from "react";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Stats from "@/components/site/Stats";
import About from "@/components/site/About";
import Portfolio from "@/components/site/Portfolio";
import MarketPulse from "@/components/site/MarketPulse";
import Philosophy from "@/components/site/Philosophy";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

const Landing = () => {
  return (
    <main
      data-testid="landing-page"
      className="relative min-h-screen bg-[#0A0A0A] text-[#F8F8F8]"
    >
      <Navbar />
      <Hero />
      <Stats />
      <About />
      <Portfolio />
      <MarketPulse />
      <Philosophy />
      <Contact />
      <Footer />
    </main>
  );
};

export default Landing;
